import React, { useState, useRef, useEffect, } from 'react'
import Loader from '../components/Loader';


import 'select2/dist/css/select2.min.css';
import 'select2';

import { useNavigate, } from 'react-router-dom';
import { companyDataByID, AddBadgeDetails, fetchBadgeByCIdandMain, editBadgeDetails } from '../api/company';

import { useParams } from 'react-router-dom';
import PopupModal from '../components/PopupModal';
import useUserStore from '../store/useUserStore';
import { extractBadgeDetails } from '../utils/badgeFormatter';


export default function AddBadge() {
    const navigate = useNavigate();
    const { cid, main } = useParams();
    const { user } = useUserStore();
    console.log(cid, main);

    useEffect(() => {

        const getDataByIDAndMain = async (cid, main) => {
            const res = await fetchBadgeByCIdandMain(cid, main)
            if (res.status > 199 && res.status < 400) {

                let data = res.data.data;
                console.log("data", data);
                const { Badgeandtopic, Accept, Auth, ClientID, Office, Badges, userName, password } = data.Badges[main];

                // const Badgeandtopic = Badges[main].Badgeandtopic;
                const badgeTopics = Badgeandtopic.map(b => ({
                    _id: b._id,        // keep the badge _id
                    Badge: b.Badge,
                    // { name } when saved here, a plain string when it came from the portal.
                    Topic: b.Topic && b.Topic[0] ? (typeof b.Topic[0] === "object" ? b.Topic[0].name || "" : String(b.Topic[0])) : "",
                    tID: (b.Topic && b.Topic[0] && b.Topic[0]._id) ? b.Topic[0]._id : "",
                    //Topic: b.Topic.map(t => ({ name: t.name, _id: t._id }))  // preserve topic _id
                }));

                setFormData({
                    previousMain: main,
                    main, Accept, Auth, ClientID, Office, badgeTopics, userName, password
                });
            } else {

            }
        }
        if (cid && main) {
            getDataByIDAndMain(cid, main)
        }

    }, [cid, main]);
    const [type, setType] = useState([
        {
            "key": "",
            "value": "Select  Type"
        },
        {
            "key": "CCS",
            "value": "CCS"
        },
        {
            "key": "CNS",
            "value": "CNS"
        },
        {
            "key": "CustUK",
            "value": "CustUK"
        },
        {
            "key": "Destin8",
            "value": "Destin8"
        }
    ])

    const [showPopup, setShowPopup] = useState(false);
    const [popUpMessage, setPopUpMessage] = useState({ "title": "", "text": "" })


    const [loading, setLoading] = useState(false);

    let formInput = {
        main: "",
        Accept: "application/vnd.hmrc.2.0+xml",
        Auth: "auth",
        ClientID: "",
        Office: "",
        previousMain: "",
        userName: "",
        password: "",
        badgeTopics: [{ Badge: "", Topic: "" }]

    };
    let [formData, setFormData] = useState(formInput);

    const [errors, setErrors] = useState({
        badgeTopics: []
    });
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");

    const validate = () => {
        const newErrors = {
            badgeTopics: []
        };

        if (!formData.main) newErrors.main = 'Please select';
        if (!formData.Accept) newErrors.Accept = 'Accept is required';
        if (!formData.Auth) newErrors.Auth = 'Auth is required';
        if (!formData.ClientID) newErrors.ClientID = 'Client ID is required';
        if (!formData.Office) newErrors.Office = 'Office is required';

        formData.badgeTopics.forEach((item, index) => {
            const badgeErrors = {};
            if (!item.Badge) badgeErrors.Badge = 'Badge is required';
            if (!item.Topic) badgeErrors.Topic = 'Topic is required';
            newErrors.badgeTopics[index] = badgeErrors;
        });

        setErrors(newErrors);

        // Check if any badge errors exist
        const hasErrors = Object.keys(newErrors).some(key => {
            if (key === "badgeTopics") {
                return newErrors.badgeTopics.some(b => b && (b.Badge || b.Topic));
            }
            return newErrors[key];
        });

        return !hasErrors;
    };

    const handleRegistration = async (e) => {
        e.preventDefault();

        if (!validate()) {
            setApiError("Please add required fields")
            setErrorStatus('danger')
            return;
        }

        try {
            setLoading(true);
            let response = "";

            const transformedData = {
                ...formData,
                badgeTopics: formData.badgeTopics.map((item) => ({
                    ...(item._id && { _id: item._id }),
                    Badge: item.Badge,
                    Topic: [
                        {
                            name: item.Topic,
                            ...(item.tID && { _id: item.tID }),
                        }
                    ]
                }))
            };

            if (cid && main) {
                response = await editBadgeDetails(cid, transformedData);
            } else {

                let dbList = [];
                if (user.db === "tdr") {
                    dbList = ["tdr"]
                } else {
                    dbList = [user.db]
                }

                let newTransformedData = { ...transformedData, dbList: dbList }
                response = await AddBadgeDetails(cid, newTransformedData);

            }

            if (response.status > 199 && response.status < 400) {
                if (cid && main) {
                } else {
                    setFormData(formInput);
                }

                setPopUpMessage({
                    "title": "Success",
                    "text": response.data.message
                });
                setShowPopup(true);
            } else {

                setPopUpMessage({
                    "title": "Error",
                    "text": response.response.data.message
                });
                setShowPopup(true);
            }
        } catch (error) {

            const message = error?.data?.message || error?.statusText || 'Login failed';
            setApiError(message);
            setTimeout(() => {
                setApiError(null);
                setErrorStatus('danger')

            }, 5000);
        } finally {
            setLoading(false);
        }
    };



    const handleChange = (e, index = null) => {
        const { name, value } = e.target;

        if (index !== null) {
            const updated = [...formData.badgeTopics];
            updated[index][name] = value;
            setFormData(prev => ({ ...prev, badgeTopics: updated }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const addBadgeTopic = () => {
        setFormData(prev => ({
            ...prev,
            badgeTopics: [...prev.badgeTopics, { Badge: "", Topic: "" }]
        }));
    };

    const removeBadgeTopic = (index) => {
        const updatedBadgeTopics = [...formData.badgeTopics];
        updatedBadgeTopics.splice(index, 1);
        setFormData(prev => ({ ...prev, badgeTopics: updatedBadgeTopics }));

        const updatedErrors = [...errors.badgeTopics];
        updatedErrors.splice(index, 1);
        setErrors(prev => ({ ...prev, badgeTopics: updatedErrors }));
    };
    const HandleGoTO = async () => {
        navigate(`/badge`)
    }
    return (
        <>
            {loading && <Loader />}
            <PopupModal
                isOpen={showPopup}
                data={popUpMessage}
                onClose={() => {
                    setShowPopup(false)
                    setPopUpMessage({
                        "title": "",
                        "text": ""
                    })
                }}
            />


            <form onSubmit={handleRegistration}>
                <div className="content-wrapper">
                    <div className="page-header">
                        <h3 className="page-title"> Add Badge </h3>
                        {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}

                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <button type="submit" className="btn btn-primary me-2">{cid && main ? "Save" : "Save"}</button>
                                <button type="button" onClick={HandleGoTO} className="btn btn-success me-2">Back</button>
                            </ol>

                        </nav>
                    </div>
                    <div className="row">

                        <div className="col-md-4 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title"></h4>
                                    {/* <p className="card-description"> Basic form layout </p> */}

                                    <div className="form-group">
                                        <label >Type</label>
                                        <select className="form-select" name="main" value={formData.main} onChange={handleChange} >
                                            {type.map((obj) => (
                                                <option key={obj.key} value={obj.key}>{obj.value}</option>
                                            ))}
                                        </select>
                                        {errors.main && <span className="text-danger">{errors.main}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label >Auth</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="Auth"
                                            value={formData.Auth}
                                            onChange={handleChange}
                                            placeholder="Auth" />
                                        {errors.Auth && <span className="text-danger">{errors.Auth}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label >Accept</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="Accept"
                                            value={formData.Accept}
                                            onChange={handleChange}
                                            placeholder="Accept" />
                                        {errors.Accept && <span className="text-danger">{errors.Accept}</span>}
                                    </div>

                                    <div className="form-group">
                                        <label >ClientID</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="ClientID"
                                            value={formData.ClientID}
                                            onChange={handleChange}
                                            placeholder="Client ID" />
                                        {errors.ClientID && <span className="text-danger">{errors.ClientID}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label >Office</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="Office"
                                            value={formData.Office}
                                            onChange={handleChange}
                                            placeholder="Office" />
                                        {errors.Office && <span className="text-danger">{errors.Office}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label >User Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="userName"
                                            value={formData.userName}
                                            onChange={handleChange}
                                            placeholder="User Name" />
                                        {errors.userName && <span className="text-danger">{errors.userName}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label >Password</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            placeholder="Password" />
                                        {errors.password && <span className="text-danger">{errors.password}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-8 grid-margin">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title">Add Badge Details</h4>

                                    {formData.badgeTopics.map((item, index) => (
                                        <div className="row align-items-end mb-3" key={index}>
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label>Badge</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="Badge"
                                                        value={item.Badge}
                                                        onChange={(e) => handleChange(e, index)}
                                                        placeholder="Badge"
                                                    />
                                                    {errors.badgeTopics[index]?.Badge && (
                                                        <span className="text-danger">{errors.badgeTopics[index].Badge}</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label>Topic</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="Topic"
                                                        value={item.Topic}
                                                        onChange={(e) => handleChange(e, index)}
                                                        placeholder="Topic"
                                                    />
                                                    {errors.badgeTopics[index]?.Topic && (
                                                        <span className="text-danger">{errors.badgeTopics[index].Topic}</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                {formData.badgeTopics.length > 1 && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger"
                                                        onClick={() => removeBadgeTopic(index)}
                                                    >
                                                        Remove
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    ))}

                                    <button type="button" className="btn btn-outline-primary mt-2" onClick={addBadgeTopic}>
                                        + Add More
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </>

    )
}
